import { z } from 'zod'

export const AvvStatus = z.object({
  accepted: z.boolean(),
  accepted_at: z.string().datetime().optional(),
  accepted_version: z.number().int().optional(),
  current_version: z.number().int(),
  needs_reaccept: z.boolean(),
  // Whether the account holds a service the agreement covers and has not opted out; absent from an older backend.
  required: z.boolean().optional(),
  opted_out: z.boolean().optional(),
  opted_out_at: z.string().datetime().optional()
})

export type AvvStatus = z.infer<typeof AvvStatus>

export const AvvAcceptResponse = z.object({
  accepted_at: z.string().datetime(),
  version: z.number().int()
})

export type AvvAcceptResponse = z.infer<typeof AvvAcceptResponse>
